import * as types from "./loginActionTypes";
import api from "./loginApi";
import keycloakManager from "./sso/keycloakManager";

export function login(data) {
  return {
    type: types.LOGIN,
    promise: api.login(data),
  };
}

export function verifyAuth() {
  return {
    type: types.LOGIN,
    promise: api.login(),
    isVerifying: true,
  };
}

export function logout(redirectURI=null) {
  return {
    type: types.LOGOUT,
    promise: keycloakManager.logout(redirectURI),
  };
}

export function clearErrors() {
  return {
    type: types.LOGIN_CLEAR_ERRORS,
  };
}

export function resetPassword(data, token, callback) {
  return {
    type: types.RESET_PASSWORD,
    promise: api.resetPassword(data, token, callback),
  };
}

export function validatePasswordResetToken(token) {
  return {
    type: types.VALIDATE_TOKEN,
    promise: api.validatePasswordResetToken(token),
  };
}

export function initiatePasswordReset(data) {
  return {
    type: types.INITIATE_PASSWORD_RESET,
    promise: api.sendPasswordResetLink(data),
  };
}



// WEBPACK FOOTER //
// ./src/components/login/loginActions.js